import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classnames from 'classnames';
import { isIE } from 'react-device-detect';

import {
  buttons as Buttons,
  buttonsV2 as ButtonsV2,
  pills as Pills,
} from '@breezeway/brzw-components';

const { PRIMARY, THIRD } = Pills.constants.PILL_THEMES;
const { MEDIUM, SMALL } = Pills.constants.PILL_SIZES;

const FilterPills = ({ filters, isMobile, onClearFilters }) => (
  <div className={classnames('filter-pills', { '-new-header': isMobile === false })}>
    <div
      className={classnames('filter-pills-wrapper', {
        'filter-pills-wrapper--ie': isIE,
      })}
    >
      {_.map(filters, (filter, index) => (
        <Pills.Pill
          className="filter-pills__pill"
          key={`filter-pill-${index}`}
          onClick={filter.onClearFilter}
          size={isMobile ? MEDIUM : SMALL}
          text={`${filter.pillLabel || filter.label}: "${filter.value}"`}
          theme={isMobile ? PRIMARY : THIRD}
        />
      ))}
    </div>
    {isMobile ? (
      <Buttons.TextButton
        autoWidth
        className="filter-pills__clear"
        onClick={onClearFilters}
        theme={Buttons.constants.BUTTON_THEMES.LINK}
      >
        Clear
      </Buttons.TextButton>
    ) : (
      <ButtonsV2.TextButton
        className="filter-pills__clear"
        onClick={onClearFilters}
        theme={ButtonsV2.constants.BUTTON_THEMES.SUBTLE}
      >
        Clear all
      </ButtonsV2.TextButton>
    )}
  </div>
);

FilterPills.propTypes = {
  isMobile: PropTypes.bool,
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      label: PropTypes.string,
      pillLabel: PropTypes.string,
      value: PropTypes.string,
      onClearFilter: PropTypes.func,
    }),
  ),
  onClearFilters: PropTypes.func,
};

export default FilterPills;
